import { Event } from "../../contracts";

export const mapAggregatedEventsCount = (x: Event) => {
    x.aggregatedEventsCount = x.metadata && x.metadata.aggregatedEventIds
        ? x.metadata.aggregatedEventIds.split(";").length
        : 0;

    return x;
}